import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'

import App from './App.jsx'
import './styles.css'
// Строго после основного файла: медиазапросы перекрывают правила той же
// специфичности, и при обратном порядке узкий экран получил бы вид широкого.
import './styles.adaptive.css'
// Версия для слабовидящих - последней: в режиме она перекрывает и широкую, и
// узкую раскладку (02.10.2026).
import './styles.lowvision.css'

createRoot(document.getElementById('root')).render(
  <StrictMode>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </StrictMode>,
)
